import styled, {css} from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content:space-around;
  width: 100%;
  ${(props)=>(props.fullscreen&&css`
    position: absolute;
    height:100%;
    background-color: #FFFFFF;
    top: 0;
    z-index: 10;
  `)};

  ${(props)=>(props.visible?
    css`
      display: flex;
    `:
    css`
      display: none;
    `
  )};
`;

export const ButtonClose = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 5rem;
  width: 100%;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 2rem;
`;
